import { Box, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import theme from '../../theme';
import { useState } from 'react';
import CustomMenu from './CustomMenu';

const SelectFilter = ({
  label,
  value,
  onChange,
  options,
  hideLabelOnMobile = false,
  valueIconGap = 0.5,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleOptionClick = (val) => {
    onChange(val);
    handleClose();
  };

  const selectedOption = options.find((option) => option.value === value);

  const menuItems = options.map((option) => ({
    text: option.label,
    onClick: () => handleOptionClick(option.value),
    selected: option.value === value,
  }));

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', height: 24, gap: 1 }}>
      <Typography
        fontSize={{ xs: 13, md: 14 }}
        color={theme.palette.black[3]}
        sx={{ display: hideLabelOnMobile ? { xs: 'none', md: 'block' } : 'block' }}
      >
        {label}
      </Typography>
      <Box
        onClick={handleClick}
        sx={{
          display: 'flex',
          alignItems: 'center',
          cursor: 'pointer',
          gap: valueIconGap,
          fontSize: { xs: 13, md: 14 },
          color: theme.palette.black[3],
        }}
      >
        <Typography fontSize={{ xs: 13, md: 14 }} color={theme.palette.black[3]}>
          {selectedOption?.label}
        </Typography>
        {open ? (
          <ExpandLessIcon sx={{ fontSize: 16, color: theme.palette.black[3] }} />
        ) : (
          <ExpandMoreIcon sx={{ fontSize: 16, color: theme.palette.black[3] }} />
        )}
      </Box>

      <CustomMenu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        items={menuItems}
      />
    </Box>
  );
};

export default SelectFilter;
